<div class="swiss-made">
  <div class="divider"></div>
  <div class="container">
    <div class="col flex-start">
      <div><app-ds-rounded-icon icon="shield-check" variant="custom" customColor="var(--color-core-neutral-3)"></app-ds-rounded-icon></div>
      <div>
        <p class="ds-ui-3">
          {{ 'swissMade.footer.guarantee' | translate }}
          <a (click)="toggleGuaranteeModal()">{{'swissMade.footer.more' | translate}}</a>
        </p>
      </div>
    </div>
    <div class="col">
      <div>
        <p class="ds-ui-3 swiss-made-copy" [innerHTML]="'swissMade.footer.swiss' | translate"></p>
      </div>
      <div><img src="/assets/images/ch-flag.svg" alt="{{ 'swissMade.footer.swiss' | translate }}" /></div>
    </div>
  </div>
  <app-guarantee *ngIf="showGuarantee" [isLoggedIn]="false" [location]="appLocation" (guaranteeOpened)="toggleGuaranteeModal()"></app-guarantee>
</div>
